import Api from "./Api";
import { WidgetCard } from "../types";

export default class WidgetCardsController extends Api {
  static create(widgetId: string, card: WidgetCard) {
    return fetch(`/api/widgets/${widgetId}/cards`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ card: card }),
    }).then((res) => res.json());
  }

  static update(widgetId: string, card: WidgetCard) {
    return fetch(`/api/widgets/${widgetId}/cards/${card.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ card: card }),
    }).then((res) => res.json());
  }

  static delete(widgetId: string, id: string) {
    return fetch(`/api/widgets/${widgetId}/cards/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }
}
